const policy = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return /(?=[^a-z]*[a-z])(?=[^0-9]*[0-9]).{6,}/gi.test(value);
};
export default policy;
